.alert_overlay {
	display: none;
	position: fixed;
	width: 100%;
	height: 100%;
	min-width: 100%;
	min-height: 100%;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	background: rgba(0, 0, 0, 0.45);
	z-index: 9999;
	animation: fadeIn both 0.5s;
}

.spinner_wrapper {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;

	.spinner {
		position: relative;
		margin: 0px auto;
		width: 68px;
		height: 68px;

		svg {
			animation: rotate 1s infinite linear;
		}
	}
}

.alert_message {
	position: fixed;
	bottom: 0;
	right: 0;
	left: 0;
	width: 100%;
	max-width: 450px;
	margin: 0 auto;
	min-height: 438px;
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	align-items: center;
	text-align: center;
	padding: 46px 20px 20px 20px;
	background-color: #fff;
	border-radius: 10px 10px 0 0;
	transform: translateY(100%);
	animation: slide both 0.4s 1s ease;
	z-index: 11;

	.alert_message_title {
		font-weight: 700;
		font-size: 26px;
		line-height: 32px;
		text-align: center;
		letter-spacing: 0.41px;
		color: #030303;
	}

	.alert_message_description {
		margin-top: 15px;
		font-weight: 400;
		font-size: 17px;
		line-height: 22px;
		text-align: center;
		color: #030303;
	}

	.image_action {
		margin-top: 20px;
		width: 184px;
		min-width: 184px;
		filter: grayscale(1);
	}

	.alert_message_button {
		margin-top: 43px;
		width: 100%;
		height: 50px;
		min-height: 50px;
		background: var(--ed-brand, #ae66f6);
		border-radius: 100px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-weight: 500;
		font-size: 22px;
		line-height: 28px;
		text-align: center;
		letter-spacing: 0.0352px;
		color: #fff;

		&:active {
			opacity: 0.5;
		}
	}
}

@keyframes rotate {
	0% {
		transform: rotate(0);
	}
	100% {
		transform: rotate(360deg);
	}
}

@keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes slide {
    from {
		transform: translateY(100%);
    }
    to {
		transform: translateY(0);
    }
  }

:global {
	#alert.active {
		display: block;

		#alertMessage {
			transform: translateY(0);
		}

	}
}
